<template>
  <div>
    <button
      id="displayOptions-button"
      ref="displayOptionsButton"
      class="cesium-button cesium-toolbar-button"
      title="Display options"
    >
      <v-icon
        id="displayOptions-icon"
        ref="displayOptionsIcon"
        name="filter"
        color="white"
        title="Display options"
      ></v-icon>
    </button>
    <div id="display-options-list" ref="displayOptionsDropdown">
      <slot name="displayOptions"></slot>
    </div>
  </div>
</template>

<script>
import { CesiumInitialization } from './CesiumInitialization'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

export default {
  name: 'cesium-display-options-list',
  mixins: [CesiumInitialization],
  props: [],

  components: {
    'v-icon': Icon
  },

  data() {
    return {}
  },

  computed: {
    cesiumViewer() {
      return this.$parent.viewer
    }
  },

  methods: {
    insertDisplayOptionsInToolbar(container) {
      this.insertElementInToolbar(this.$refs.displayOptionsDropdown, container)
      this.insertElementInToolbar(this.$refs.displayOptionsButton, container)
    }
  }
}
</script>

<style scoped lang="scss">
#displayOptions-icon {
  z-index: 99;
}

#displayOptions-button:hover ~ #display-options-list {
  visibility: visible !important;
  opacity: 1 !important;
  transform: translate(0, 0) !important;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}

#display-options-list:hover {
  visibility: visible !important;
  opacity: 1 !important;
  transform: translate(0, 0) !important;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}

#display-options-list {
  position: absolute;
  top: auto;
  right: 0;
  height: fit-content;
  max-height: 250px;
  margin-top: 5px;
  padding: 6px;
  display: grid;
  border: 1px solid #444;
  background-color: rgba(38, 38, 38, 0.75);
  box-sizing: content-box;
  grid-template-columns: 100%;
  grid-row-gap: 1em;
  overflow-y: auto;
  overflow-x: none;
  border-radius: 10px;
  user-select: none;
  transform: translate(0, -20%);
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 0.2s, opacity 0.2s ease-in, transform 0.2s ease-in;
  scrollbar-width: thin;
  scrollbar-color: #444 rgba(255, 255, 255, 0.75);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.75);
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #444;
    border-radius: 100px;
  }
}
</style>
